import React, { useMemo, useState } from "react";
import { Modal, Button, Form, Tooltip, OverlayTrigger} from "react-bootstrap";
import { CopyButton } from "../Buttons/CopyButton";


export default function KsefInvoiceModal({ show, onHide, trx }) {

    const [send, setSend] = useState(false);

    const handleSend = async () => {
        setSend(true);
        setTimeout(() => setSend(false), 1500);
    };

    const pln = new Intl.NumberFormat("pl-PL", { style: "currency", currency: "PLN" });

    function formatNip(input) {
        if (input === null || input === undefined) return input;
        const original = String(input);
        const s = original.trim();
        if (!s) return original;
        const prefixMatch = s.match(/^([A-Za-z]{2})/);
        const prefix = prefixMatch ? prefixMatch[1].toUpperCase() : "";
        const digits = s.replace(/\D/g, "");
        if (digits.length !== 10) return original;  
        const formattedDigits = `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6, 8)}-${digits.slice(8, 10)}`;
        if (prefix) return `${prefix}${formattedDigits}`;
        return formattedDigits;
    }

  return (
    <>
        <Modal show={show} onHide={onHide} centered backdrop="static">
        <Modal.Header closeButton>
            <Modal.Title>Faktura do paragonu</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Form>
                <Form.Group className="mb-2">
                    <Form.Label>Numer</Form.Label>
                    <div className="d-flex align-items-center">
                        <Form.Control value={trx?.InfoObj?.InvoiceNumber} readOnly />
                        <CopyButton value={trx?.InfoObj?.InvoiceNumber} label="Kopiuj"/>
                    </div>
                </Form.Group>
                <Form.Group className="mb-2">
                    <Form.Label>NIP nabywcy</Form.Label>
                    <div className="d-flex align-items-center">
                        <Form.Control value={formatNip(trx?.InfoObj?.NIP)} readOnly />
                        <CopyButton value={trx?.InfoObj?.NIP} label="Kopiuj"/>
                    </div>
                </Form.Group>
                <Form.Group className="mb-2">
                    <Form.Label>Kwota należności ogółem</Form.Label>
                    <div className="d-flex align-items-center">
                        <Form.Control value={pln.format(Number(trx?.Price))} readOnly />
                        <CopyButton value={trx?.Price} label="Kopiuj"/>
                    </div>
                </Form.Group>
                <Form.Group className="mb-2">
                    <Form.Label>KSeF</Form.Label>
                    <div className="d-flex align-items-center">
                        <Form.Control value={trx?.InfoObj?.KsefUrl} readOnly/>
                        <Button as="a" href={trx?.InfoObj?.KsefUrl} target="_blank" rel="noreferrer" variant="outline-primary">
                            <i className="fas fa-external-link-alt" />
                        </Button>
                    </div>
                </Form.Group>
                <Form.Group className="mb-2">
                    <div className="d-flex align-items-center">
                        <Form.Control value="Wyślij fakturę na email" readOnly className="bg-white"/>
                        <OverlayTrigger placement="top" overlay={<Tooltip>{send ? "Wysłano!" : "Kliknij, aby wysłać"}</Tooltip>}>
                        <Button variant={send ? "success" : "outline-primary"} onClick={handleSend}>
                            <i className="fas fa-paper-plane"/>
                        </Button>
                        </OverlayTrigger>
                    </div>
                </Form.Group>
            </Form>
        </Modal.Body>

        <Modal.Footer>
            <Button variant="secondary" onClick={onHide}>
            Zamknij
            </Button>
        </Modal.Footer>
        </Modal>
    </>
  );
}